export default {
  // tako pušaš končno verzijo objekta (requesta) z vsemi pravimi imeni
  addRequest(state, payload) {
    state.requests.push(payload);
  },
};
